import "core-js/modules/es6.array.index-of";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.array.for-each";
import lodashPick from 'lodash.pick';
export var getRepeatedItems = function getRepeatedItems(items) {
  if (!items) return items;
  var list = [];
  items.forEach(function (item, index) {
    var filteredSelf = _toConsumableArray(items);

    filteredSelf.splice(index, 1);

    if (filteredSelf.indexOf(item) !== -1 && list.indexOf(item) === -1) {
      // is repeated
      list.push(item);
    }
  });
  return list;
};
export var pick = function pick(object) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return object ? lodashPick.apply(void 0, [object].concat(args)) : object;
};